<template>
  <div id="contenedor-entidades-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EntidadesMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
